<template>
  <div class="android-app-page">
    <page-navigate></page-navigate>
    <div class="androidApp_hero">
      <div class="heroContent">
        <h1 class="hero-title">正在为您准备下载 EBC Android App</h1>
        <p class="hero-subtitle">下载将自动开始，请稍候。若长时间未响应，可点击下方按钮手动下载。</p>

        <div class="phoneWrap">
          <div class="floatIcon floatIcon--chart">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 17L9 11L13 15L21 7" stroke="#B00000" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M16 7H21V12" stroke="#B00000" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
          <div class="phone">
            <div class="phone-screen">
              <svg class="androidRobot" viewBox="0 0 24 24" fill="#3DDC84" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 18c0 .55.45 1 1 1h1v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h2v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h1c.55 0 1-.45 1-1V8H6v10zM3.5 8C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5S5 17.33 5 16.5v-7C5 8.67 4.33 8 3.5 8zm17 0c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zm-4.97-5.84l1.3-1.3c.2-.2.2-.51 0-.71-.2-.2-.51-.2-.71 0l-1.48 1.48C13.85 1.23 12.95 1 12 1c-.96 0-1.86.23-2.66.63L7.85.15c-.2-.2-.51-.2-.71 0-.2.2-.2.51 0 .71l1.31 1.31C6.97 3.26 6 5.01 6 7h12c0-1.99-.97-3.75-2.44-4.84zM10 5H9V4h1v1zm5 0h-1V4h1v1z" />
              </svg>
              <div class="downloadArrow">
                <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M24 6V32M24 32L14 22M24 32L34 22" stroke="#1a1a1a" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M12 40H36" stroke="#B00000" stroke-width="3" stroke-linecap="round" />
                </svg>
              </div>
            </div>
          </div>
          <div class="floatIcon floatIcon--candle">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 4V20" stroke="#B00000" stroke-width="1.6" stroke-linecap="round" />
              <rect x="6" y="8" width="4" height="8" rx="1" fill="#B00000" />
              <path d="M16 3V21" stroke="#1a1a1a" stroke-width="1.6" stroke-linecap="round" />
              <rect x="14" y="7" width="4" height="9" rx="1" fill="#1a1a1a" />
            </svg>
          </div>
        </div>

        <div class="downloadBox">
          <a class="downloadBtn" :href="androidUrl || 'javascript:void(0)'" @click="manualDownload">
            <span>手动下载 Android 版</span>
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 4V16M12 16L7 11M12 16L17 11" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M5 19H19" stroke="#fff" stroke-width="1.8" stroke-linecap="round" />
            </svg>
          </a>
          <p class="downloadTip">请在浏览器中打开以获得最佳下载体验</p>
        </div>
      </div>

      <div class="featureBar">
        <div class="featureBar-inner">
          <div class="featureItem" v-for="(item, index) in features" :key="index">
            <i :class="['bi', item.icon]"></i>
            <div class="featureText">
              <div class="featureTitle">{{ item.title }}</div>
              <div class="featureDesc">{{ item.desc }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <page-footer></page-footer>
  </div>
</template>

<script>
export default {
  name: "AndroidApp",
  data() {
    return {
      androidUrl: "",
      hasAutoDownloaded: false,
      features: [
        { icon: "bi-shield-check", title: "安全可靠", desc: "官方正版应用安全保障" },
        { icon: "bi-bar-chart-line", title: "专业交易", desc: "全球市场 便捷交易" },
        { icon: "bi-lightning-charge", title: "极速体验", desc: "稳定流畅 高效执行" },
        { icon: "bi-headset", title: "专业支持", desc: "7×24 小时专属服务" },
      ],
    };
  },
  mounted() {
    document.documentElement.setAttribute("data-fitter", "true");
    this.getApkURL();
  },
  destroyed() {
    document.documentElement.removeAttribute("data-fitter");
  },
  methods: {
    getApkURL() {
      fetch("https://www.ebc.site/portal/AppInfo/getDownloadLink")
        .then((res) => res.json())
        .then((res) => {
          if (res && res.code === 0 && res.data) {
            this.androidUrl = res.data.android_download_link;
            this.autoDownload();
          }
        })
        .catch((err) => {
          console.error("获取下载链接失败：", err);
        });
    },
    autoDownload() {
      if (!this.androidUrl || this.hasAutoDownloaded) return;
      this.hasAutoDownloaded = true;
      this.triggerDownload();
    },
    manualDownload(e) {
      e.preventDefault();
      if (!this.androidUrl) {
        this.getApkURL();
        return;
      }
      this.triggerDownload();
    },
    triggerDownload() {
      const link = document.createElement("a");
      link.href = this.androidUrl;
      link.setAttribute("download", "");
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
};
</script>

<style scoped lang="scss">
.androidApp_hero {
  background: #fff;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  /* 顶部固定导航高度约 80px */
  padding-top: 80px;
}

.heroContent {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 56rem 32rem 40rem;
  box-sizing: border-box;
}

.hero-title {
  text-align: center;
  font-size: 44rem;
  font-weight: 700;
  line-height: 60rem;
  color: var(--ebc-text-primary, #1a1a1a);
  margin: 0 0 16rem;
}

.hero-subtitle {
  text-align: center;
  font-size: 18rem;
  font-weight: 400;
  line-height: 28rem;
  color: var(--ebc-text-secondary, #666);
  margin: 0 0 12rem;
  max-width: 720rem;
}

.phoneWrap {
  position: relative;
  width: 460rem;
  height: 320rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.phoneWrap::before {
  content: "";
  position: absolute;
  width: 380rem;
  height: 260rem;
  border-radius: 50%;
  background: #f5f5f6;
  z-index: 1;
}

.phone {
  position: relative;
  z-index: 2;
  width: 156rem;
  height: 300rem;
  border-radius: 26rem;
  border: 4rem solid #1a1a1a;
  background: #fff;
  box-sizing: border-box;
  padding: 10rem;
  box-shadow: 0 20rem 40rem rgba(0, 0, 0, 0.1);
}

.phone::before {
  content: "";
  position: absolute;
  top: 11rem;
  left: 50%;
  transform: translateX(-50%);
  width: 7rem;
  height: 7rem;
  border-radius: 50%;
  background: #1a1a1a;
}

.phone-screen {
  width: 100%;
  height: 100%;
  border-radius: 18rem;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 36rem;
}

.androidRobot {
  width: 64rem;
  height: 64rem;
}

.downloadArrow svg {
  width: 42rem;
  height: 42rem;
}

.floatIcon {
  position: absolute;
  z-index: 3;
  width: 60rem;
  height: 60rem;
  border-radius: 16rem;
  background: #fff;
  box-shadow: 0 10rem 24rem rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
}

.floatIcon svg {
  width: 30rem;
  height: 30rem;
}

.floatIcon--chart {
  left: 24rem;
  top: 84rem;
}

.floatIcon--candle {
  right: 40rem;
  bottom: 70rem;
}

.downloadBox {
  text-align: center;
  margin-top: 44rem;
}

.downloadBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 12rem;
  min-width: 240rem;
  height: 56rem;
  padding-inline: 36rem;
  border-radius: 999rem;
  background: linear-gradient(180deg, #8a1414 0%, #5c0d0d 100%);
  color: #fff;
  font-size: 17rem;
  font-weight: 500;
  text-decoration: none;
  box-sizing: border-box;
  transition: opacity 0.2s ease;
}

.downloadBtn:hover {
  opacity: 0.9;
}

.downloadBtn svg {
  width: 20rem;
  height: 20rem;
}

.downloadTip {
  margin: 16rem 0 0;
  font-size: 14rem;
  color: var(--ebc-text-tertiary, #999);
}

.featureBar {
  padding: 24rem 32rem 40rem;
}

.featureBar-inner {
  max-width: 1120rem;
  margin-inline: auto;
  background: #fafafa;
  border-radius: 16rem;
  padding: 28rem 40rem;
  display: flex;
  justify-content: space-between;
  gap: 24rem;
}

.featureItem {
  display: flex;
  align-items: center;
  gap: 14rem;
  flex: 1;
  min-width: 0;
}

.featureItem .bi {
  font-size: 30rem;
  color: var(--ebc-brand-secondary-red, #b00000);
  line-height: 1;
  flex-shrink: 0;
}

.featureTitle {
  font-size: 16rem;
  font-weight: 600;
  color: var(--ebc-text-primary, #1a1a1a);
  margin-bottom: 4rem;
}

.featureDesc {
  font-size: 13rem;
  color: var(--ebc-text-tertiary, #999);
}

@media (max-width: 996px) {
  .androidApp_hero {
    /* 移动端固定导航高度约 44px */
    padding-top: 44px;
  }

  .heroContent {
    padding: 80rem 40rem 60rem;
  }

  .hero-title {
    font-size: 48rem;
    line-height: 68rem;
    margin-bottom: 24rem;
  }

  .hero-subtitle {
    font-size: 26rem;
    line-height: 42rem;
    margin-bottom: 24rem;
    max-width: 100%;
  }

  .phoneWrap {
    width: 100%;
    height: 620rem;
  }

  .phoneWrap::before {
    width: 560rem;
    height: 440rem;
  }

  .phone {
    width: 300rem;
    height: 580rem;
    border-radius: 48rem;
    border-width: 7rem;
    padding: 18rem;
  }

  .phone::before {
    top: 20rem;
    width: 12rem;
    height: 12rem;
  }

  .phone-screen {
    border-radius: 32rem;
    gap: 72rem;
  }

  .androidRobot {
    width: 124rem;
    height: 124rem;
  }

  .downloadArrow svg {
    width: 80rem;
    height: 80rem;
  }

  .floatIcon {
    width: 104rem;
    height: 104rem;
    border-radius: 24rem;
  }

  .floatIcon svg {
    width: 52rem;
    height: 52rem;
  }

  .floatIcon--chart {
    left: 40rem;
    top: 150rem;
  }

  .floatIcon--candle {
    right: 40rem;
    bottom: 130rem;
  }

  .downloadBox {
    margin-top: 24rem;
    width: 100%;
  }

  .downloadBtn {
    width: 100%;
    min-width: 0;
    height: 96rem;
    font-size: 30rem;
    gap: 20rem;
    border-radius: 999rem;
  }

  .downloadBtn svg {
    width: 34rem;
    height: 34rem;
  }

  .downloadTip {
    margin-top: 28rem;
    font-size: 24rem;
  }

  .featureBar {
    padding: 40rem 40rem 80rem;
  }

  .featureBar-inner {
    flex-wrap: wrap;
    padding: 48rem 40rem;
    row-gap: 56rem;
    border-radius: 24rem;
  }

  .featureItem {
    flex: 0 0 50%;
    box-sizing: border-box;
    gap: 20rem;
  }

  .featureItem .bi {
    font-size: 52rem;
  }

  .featureTitle {
    font-size: 28rem;
    margin-bottom: 6rem;
  }

  .featureDesc {
    font-size: 22rem;
  }
}
</style>
